'use strict';

angular.module('cloudBillingLegacyFrontend').controller('ModalMessageBoxCtrl', function($scope, $modalInstance, $controller, Metadata) {

  $scope.title = Metadata.Title;
  $scope.description = Metadata.Description;

  $scope.ok = function () {
    $modalInstance.close();
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

});



